import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Spinner, OverlayTrigger, Popover  } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import ChemComponent from '../ChemComponent';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';

class Home extends ChemComponent {	
	constructor(props) {
		super(props);

		this.state = {
			searchCount: null,
			renderKey: 1
		};
	}

	viewJob(jobId) {
		this.props.navigate('/Jobtrack/Jobs/' + jobId);
	}

	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Speedtype Changes',
			columns: exportColumns,
			entity: 'RECHARGES.SHOPS_SPEEDTYPE_CHANGES_VW',
			order: 'JOB_ID desc'
		});	

		return(
			<Container fluid>
			  <Row>
			    <Col md={12} lg={11} xl={10} style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
				    <Row>
					  <Col>
						<img src={this.getConfig().host + '/Content/Icons/ShopsJobTrack.png'} alt={'Shops Job Track'}/>
					  </Col>
					</Row>
					<Row>
					  <Col xs={3} style={{ marginTop: 18}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 16}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 16}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			  <Row>
			    <Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Speedtype_Changes' table={jobList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='240px' />
				</Col>
			  </Row>
			</Container>
		);
	}
}

const jobList = {
	query: { entity: 'RECHARGES.SHOPS_SPEEDTYPE_CHANGES_VW', order: 'JOB_ID desc' },
	pageSize: 20,
	columns: [
		{ Header: 'Job ID', accessor: 'JOB_ID',
			Cell: props => <HashLink onClick={() => props.parent.viewJob(props.value)}>{props.value}</HashLink> },
		{ Header: 'Previous Speedtype(s)', accessor: 'DEL_SPEEDTYPE', width: 260,
			Cell: props => props.parent.getTableFragment(props.value, [110,150]) },
		{ Header: 'Current Speedtype', accessor: 'CUR_SPEEDTYPE', width: 250,
			Cell: props => props.parent.getCellFragment(props.value) }
	]
};

const exportColumns = [
	{ Header: 'Job ID', accessor: 'JOB_ID', width: 25 },
	{ Header: 'Previous Speedtype(s)', accessor: 'DEL_SPEEDTYPE', width: 52 },
	{ Header: 'Current Speedtype', accessor: 'CUR_SPEEDTYPE', width: 50 }
];

export default withRouter(Home);